<section class="scr-page scr-page--compact container-prod">
  <div class="scr-master-detail">
    <div class="head-list scr-card scr-card--padded">
      <tp-page-header
        variant="toolbar"
        class="tp-page-header--flat"
        title="Productos"
        [subtitle]="products.length + (products.length === 1 ? ' producto' : ' productos')"
      >
        <div class="scr-search">
          <mat-icon class="scr-search__icon" aria-hidden="true">search</mat-icon>
          <input
            type="text"
            class="form-control"
            placeholder="Buscar Producto"
            [(ngModel)]="searchText"
            />
        </div>
        <button mat-flat-button actions class="scr-btn-primary" type="button" (click)="cleanForm()">
          <mat-icon>add</mat-icon>
          Nuevo producto
        </button>
      </tp-page-header>

        <div class="list">
          <div class="row productsListTitle text-left">
            <b>Productos</b>
          </div>
          <ul class="scrollable-content">
            @for (prod of products | filterByProductName : searchText; track prod) {
              <li
                class="scr-list-item"
                [class.scr-list-item--selected]="isSelectedProduct(prod)"
                [attr.aria-current]="isSelectedProduct(prod) ? 'true' : null"
              >
                <div class="elem-row">
                  <div
                    class="col-md-4 description"
                [ngStyle]="{
                  'pointer-events': disableEdit ? 'none' : 'auto',
                  cursor: disableEdit ? 'not-allowed' : 'pointer'
                }"
                    >
                    <span
                      (click)="editProduct(prod)"
                      (keydown)="onKeyDownInObservations($event, prod)"
                      >{{ prod.name }}</span
                      >
                    </div>
                    <div class="col-md-7 description">
                      <span>{{ prod.description }}</span>
                    </div>
                    <div class="col-md-1 elem-row__action">
                      <mat-icon
                        (click)="deleteProduct(prod)"
                        title="deleteProduct"
                        class="align-self-center"
                        style="cursor: pointer; color: grey"
                        tabindex="-1"
                        (keydown)="deleteProduct(prod)"
                        >delete_outlined
                      </mat-icon>
                    </div>
                  </div>
                </li>
              }
            </ul>
          </div>
        </div>

        <div class="form-container scr-card scr-card--padded">
          <div class="scr-detail-head">
            @if (hasSelectedProduct()) {
              <h2 class="scr-section-title">Editando: {{ productForm.controls['name'].value }}</h2>
              <p class="scr-detail-head__sub">{{ productForm.controls['alias'].value }}</p>
            } @else {
              <h2 class="scr-section-title">Elegí un producto de la lista</h2>
              <p class="scr-detail-head__sub">O completá los datos para crear uno nuevo.</p>
            }
          </div>
          <form [formGroup]="productForm" class="product pl-form" (ngSubmit)="onSubmit()">
            <div class="cf-grid">
              <div class="cf-field">
                <label class="cf-label" for="pl-name">Nombre</label>
                <input id="pl-name" class="cf-input" placeholder="Nombre" name="name" formControlName="name" required />
                @if (productForm.controls['name'].invalid && productForm.controls['name'].touched) {
                  <span class="cf-error">El nombre es obligatorio.</span>
                }
              </div>
              <div class="cf-field">
                <label class="cf-label" for="pl-alias">Alias</label>
                <input id="pl-alias" class="cf-input" placeholder="Alias" name="alias" formControlName="alias" maxlength="20" required />
                @if (productForm.controls['alias'].invalid && productForm.controls['alias'].touched) {
                  <span class="cf-error">El alias es obligatorio.</span>
                }
              </div>
              <div class="cf-field cf-field--full">
                <label class="cf-label" for="pl-description">Descripción</label>
                <textarea
                  id="pl-description"
                  class="cf-input"
                  cdkAutosizeMinRows="5"
                  type="text"
                  placeholder="Descripción"
                  name="description"
                  formControlName="description"
                  rows="6"
                  required
                ></textarea>
                @if (productForm.controls['description'].invalid && productForm.controls['description'].touched) {
                  <span class="cf-error">La descripción es obligatoria.</span>
                }
              </div>
              <div class="cf-field">
                <label class="cf-label" for="pl-group">Tipo de tarea *</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select
                    id="pl-group"
                    [formControl]="selectedGroup"
                    (selectionChange)="getSubcategories($event.value)"
                    required
                    placeholder="Elegí un tipo de tarea"
                  >
                    @for (tg of taskGroups; track tg) {
                      <mat-option [value]="tg.id.toString()">
                        {{ tg.description }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="cf-field">
                <label class="cf-label" for="pl-subcategories">Subcategorías</label>
                <div class="pl-add-row">
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-select id="pl-subcategories" multiple [formControl]="selectedSubcategories" placeholder="Elegí subcategorías">
                      @for (j of currentSubcategories; track j) {
                        <mat-option [value]="j" (click)="setIsPiscina()" tabindex="-1" (keydown)="setIsPiscina()">
                          {{ j.description }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <button mat-stroked-button type="button" title="Agregar" (click)="addSelectedCategories()">
                    <mat-icon>add</mat-icon>
                    Agregar
                  </button>
                </div>
                @if (productForm.controls['productCategories'].invalid && productForm.controls['productCategories'].touched) {
                  <span class="cf-error">Agregá al menos una tarea.</span>
                }
              </div>

              @if (isPiscina) {
                <div class="cf-field cf-field--full">
                  <label class="cf-label" for="pl-colors">Color</label>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-select id="pl-colors" multiple [compareWith]="compareObjects" formControlName="productColors" placeholder="Elegí los colores">
                      @for (color of colors; track color) {
                        <mat-option [value]="color">
                          {{ color.color }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </div>

            @if (selectedProductCategories.length > 0) {
              <div class="pl-tasks">
                <h3 class="cf-section-title">Tareas aplicadas</h3>
                <div class="tp-table-responsive">
                  <table class="table table-bordered pl-tasks__table">
                    <thead>
                      <tr>
                        <th scope="col">Grupo</th>
                        <th scope="col">Subcategoría</th>
                        <th scope="col">Precio</th>
                        <th scope="col">Duración</th>
                        <th scope="col"><span class="visually-hidden">Quitar</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (productCategory of selectedProductCategories; track productCategory; let i = $index) {
                        <tr>
                          <td>{{ productCategory.categoryDescription }}</td>
                          <td>{{ productCategory.subCategoryDescription }}</td>
                          <td class="priceColumn">
                            @if (showInputPrice(productCategory)) {
                              <div class="pl-affix pl-affix--price">
                                <span class="pl-affix__text pl-affix__text--prefix" aria-hidden="true">$</span>
                                <input
                                  class="cf-input"
                                  aria-label="Precio"
                                  appTwoDigitDecimaNumber
                                  (input)="onPriceInputChange($event, i)"
                                  value="{{ productCategory.price }}"
                                />
                              </div>
                            }
                          </td>
                          <td class="priceColumn">
                            @if (usrSvc.hasPermission('add:serviceduration')) {
                              <div class="pl-affix pl-affix--duration">
                                <input
                                  type="number"
                                  class="cf-input duration-input"
                                  aria-label="Duración en horas"
                                  [max]="durationUnits[i] === 'dias' ? 2 : 48"
                                  (input)="onDurationInputChange($event, i)"
                                  [value]="productCategory.defaultDuration"
                                  (keydown)="validateOnlyNumbers($event, i)"
                                />
                                <span class="pl-affix__text pl-affix__text--suffix" aria-hidden="true">Hs</span>
                              </div>
                            }
                          </td>
                          <td class="pl-tasks__action">
                            <button
                              mat-icon-button
                              type="button"
                              title="Quitar"
                              aria-label="Quitar"
                              (click)="removeSelectedCategory(productCategory)"
                            >
                              <mat-icon>delete_outline</mat-icon>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }

            <div class="pl-uploader" [hidden]="hideUploadFile()">
              <app-file-uploader
                [description]="'Foto del producto'"
                [settings]="uploadersetting"
                [name]="'productImg'"
              ></app-file-uploader>
            </div>

            <div class="cf-actions pl-actions">
              <button mat-flat-button id="guardar" type="button" (click)="onSubmit()">
                Guardar
              </button>
            </div>
          </form>
                </div>
              </div>
</section>
